module.exports = __webpack_public_path__ + "static/media/searchIconDark.79062df8.svg";